import { useTranslation } from 'react-i18next';

import { InvoiceDetailsInput } from '__generated__/graphql';
import Address, { containsAddress } from '../Common/Address';
import PhoneNumber from '../PhoneNumber/PhoneNumber';
import UI from '../UI';

export const hasInvoiceDetails = (invoice: InvoiceDetailsProps) => (
  invoice.company_name || invoice.reference || invoice.vat_id || containsAddress(invoice) || invoice.phone
);

interface InvoiceDetailsProps extends InvoiceDetailsInput {}

const InvoiceDetails = (invoice: InvoiceDetailsProps) => {
  const { t } = useTranslation('common');

  if (!hasInvoiceDetails(invoice)) {
    return (
      <UI.Div sc={{ color: 'gray.500' }}>
        {t('invoice_details.no_details_entered')}
      </UI.Div>
    );
  }

  return (
    <>
      {invoice.company_name && (
        <UI.Div>
          <UI.Legend sc={{ fontWeight: 500 }}>
            {t('invoice_details.company_name')}
          </UI.Legend>
          {invoice.company_name}
        </UI.Div>
      )}
      {invoice.reference && (
        <UI.Div>
          <UI.Legend sc={{ fontWeight: 500 }}>
            {t('invoice_details.reference')}
          </UI.Legend>
          {invoice.reference}
        </UI.Div>
      )}
      {invoice.vat_id && (
        <UI.Div>
          <UI.Legend sc={{ fontWeight: 500 }}>
            {t('invoice_details.vat_id')}
          </UI.Legend>
          {invoice.vat_id}
        </UI.Div>
      )}
      {containsAddress(invoice) && (
        <UI.Div>
          <UI.Legend sc={{ fontWeight: 500 }}>
            {t('invoice_details.address')}
          </UI.Legend>
          <Address {...invoice} />
        </UI.Div>
      )}
      {invoice.phone && (
        <UI.Div>
          <UI.Legend sc={{ fontWeight: 500 }}>
            {t('invoice_details.phone')}
          </UI.Legend>
          <PhoneNumber phoneNumber={invoice.phone} />
        </UI.Div>
      )}
    </>
  );
};

export default InvoiceDetails;
